'use client'
import { Carousel, CarouselContent, CarouselItem } from '@/components/ui/carousel'
import { TestimonialCard } from './testomonial-card'
import RichText from '@/components/RichText'
import Autoplay from 'embla-carousel-autoplay'

const TestomonialsCards2 = ({ testimonials, image }: { testimonials: any[]; image: any }) => {
  return (
    <section className="container mx-auto relative  z-[1]" aria-label="Testimonials">
      <div className="flex flex-wrap">
        {/* Left Image Column */}
        <aside
          className="w-full lg:w-1/2 flex items-center justify-center"
          aria-label="Testimonial Image"
        >
          <figure className="relative w-full">
            <img
              src={image?.url}
              alt="Testimonial"
              className="w-full lg:h-[42vh] picture-rounded object-cover"
            />
          </figure>
        </aside>

        {/* Right Carousel Column */}
        <section
          className="w-full lg:w-1/2 xl:w-5/12 mt-10 xl:mt-[40px] xl:ml-[-110px] z-[1]"
          aria-label="Testimonial List"
        >
          <Carousel
            opts={{
              loop: true,
            }}
            aria-label="Testimonials carousel"
            plugins={[
              Autoplay({
                delay: 3000,
                stopOnInteraction: false,
                stopOnMouseEnter: true,
                stopOnFocusIn: true,
              }),
            ]}
          >
            <CarouselContent>
              {testimonials.map((testimonial) => (
                <CarouselItem key={testimonial.id} role="list">
                  <article>
                    <TestimonialCard
                      quote={testimonial.description}
                      name={testimonial.name}
                      title={testimonial.title}
                      avatar={testimonial.photo}
                      rating={testimonial.rating}
                    />
                  </article>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </section>
      </div>
    </section>
  )
}

export default TestomonialsCards2
